export const envBoolean = (
    key: string
): boolean => {
    return process.env[key]?.trim().toLowerCase() === 'true';
};

export const envId = (
    key: string
): number => {
    const value = process.env[key]?.trim();
    const numberValue = Number(value);

    if (!value || !Number.isInteger(numberValue) || numberValue < 1) {
        return 0;
    }

    return numberValue;
};

export const envString = (
    key: string
): string => {
    const value = process.env[key]?.trim();

    if (!value) {
        return '';
    }

    return value;
};
